<!--
@Author: Calvin Green <calvin>
@Date:   2021-12-22T11:46:53+02:00
@Email:  calvin@diversitude.com
@Last modified by:   calvin
@Last modified time: 2022-08-29T10:29:42+02:00
@Copyright: Diversitude 2021
-->

<template>
    <div v-if="hasMounted"> 
        <b-row>
            <b-col :cols="tabIndex == 0 ? 10 : 12">
            <b-tabs active-nav-item-class="font-weight-bold text-primary" v-model="tabIndex" > <!-- nav-class="nav-tabs-custom" -->
                <b-tab>
                    <template #title>
                        <i class="fas fa-file me-1"></i>
                        Document View
                    </template>
                    <slot name="section-title"/>
                    <div class="document-editor" v-show="type != null">
                        <ckeditor v-model="content" :config="editorConfig" :read-only="isReadOnly" @ready="onEditorReady"></ckeditor>
                    </div>
                    <div class="document-editor" v-show="type == null && isPublished">
                        <annotate-pdf
                            v-if="b64 != null"
                            @toggleSignMode="toggleSignMode"
                            :sign_mode="false"
                            :signature_svg="client_signatures"
                            :base64="b64"/>
                            <b-alert v-else show>Waiting for document data</b-alert>
                    </div>
                    <div class="document-editor border border-grey ps-4 pt-4 pb-4 ms-1 mt-1" v-show="type == null && !isPublished && !isUploaderRevision">
                        <b-alert show>This revision is currently unpublished</b-alert>
                        <div style="max-height: 90vh; overflow-y: auto;" v-html="content"></div>
                    </div>

                    <div v-if="isUploaderRevision">
                        <b-card no-body>
                            <template #header>
                                <span v-show="hasRevisionData">
                                    Upload SOP Revision PDF File
                                </span>
                                <span v-show="hasRevisionData == false">
                                    Upload the First PDF Revision File
                                </span>
                            </template>
                            <DocumentRevisionUploader />
                        </b-card>
                    </div>
                </b-tab>

                <b-tab>
                    <template #title>
                        <i class="fas fa-heading me-1"></i>
                        Document Header
                    </template>
                    <DocumentHeader :header_details="header_details" :revision_uid="revision_uid" />
                </b-tab>
                <b-tab lazy>
                    <template #title>
                        <i class="fas fa-truck me-1"></i>
                        Distribution Logs
                    </template>
                    <DistributionLogsTable />
                </b-tab>
                <b-tab lazy>
                    <template #title>
                        <i class="fas fa-list me-1"></i>
                        Revision Logs
                    </template>
                    <RevisionLogsTable />
                </b-tab>
            </b-tabs>
            </b-col>
            <b-col v-show="tabIndex == 0" cols="2" class="left-column-border">
                <slot name="right-column"/>
            </b-col>
        </b-row>
        <SignatureModal v-if="show_signature_modal" />
    </div>
</template>

<script>
import SignatureModal from '@/components/widgets/misc/signingModal.vue'
import Swal from 'sweetalert2'
import { header_data } from './header.js'
import { sopMethods, userMethods, userState } from '@/state/helpers'
//import DecoupledEditor from "@/plugin/ckeditor-custom/ckeditor.js"
import CKEditor from 'ckeditor4-vue';
import DocumentRevisionUploader from '@/components/documents/edit/documentRevisionUploader.vue'
//import RevisionBar from '../../widgets/document/revision-bar.vue';

import RevisionLogsTable from '@/components/documents/tables/revisionLogs.vue'
import DistributionLogsTable from '@/components/documents/tables/distributionLogs.vue'
import DocumentHeader from '@/components/documents/edit/documentHeader.vue';
//import PageBreakPlugin from '@/plugin/pagebreakplugin.js'
//import VuePdfEmbed from '../../../../node_modules/vue-pdf-embed/dist/vue2-pdf-embed'
export default {
    data:() => ({
        tabIndex: 0,
        show_signature_modal: false,
        show_pdf_wrapper: false,
        sign_mode: true,
        debug_size:'',
        pause_event: false,
        doc_heading: 'Frogs',
        header_table:'',
        editor: null,
        hasMounted: false,
        //isReadOnly: false,
        content:'<h1>Hello world</h1>',
        editorConfig: {
            contentsCss: '/css/ckcustom.css',
            height: '55vh',
            on: {
                instanceReady: function (event) {
                    let dataProcessor = event.editor.dataProcessor;
                    let htmlFilter = dataProcessor && dataProcessor.htmlFilter;

                    if (htmlFilter) {
                        htmlFilter.addRules({
                            elements: {
                                p: function (element) {
                                    let style = element.attributes.style;
                                    // Ensure style attribute exists before attempting to modify it
                                    if (style) {
                                        style = style.replace(/font-family:.*?;/g, 'font-family: \'Open Sans\',\'sans-serif\';');
                                        element.attributes.style = style;
                                    }
                                    return element;
                                },
                            },
                        });
                    }
                },
            },
            extraPlugins: 'dialogui,dialog,a11yhelp,about,basicstyles,bidi,blockquote,clipboard,button,tableresize,panelbutton,panel,floatpanel,colorbutton,colordialog,menu,contextmenu,dialogadvtab,div,elementspath,enterkey,entities,popup,filebrowser,find,fakeobjects,floatingspace,listblock,richcombo,font,format,forms,horizontalrule,htmlwriter,iframe,image,indent,indentblock,indentlist,justify,link,list,liststyle,magicline,maximize,newpage,pagebreak,pastefromword,pastetext,preview,removeformat,resize,save,menubutton,scayt,selectall,showblocks,showborders,smiley,sourcearea,specialchar,stylescombo,tab,table,tabletools,templates,toolbar,undo,wysiwygarea',
        }
    }),
    components: {
        ckeditor: CKEditor.component,
        SignatureModal,
        DocumentRevisionUploader,
        RevisionLogsTable,
        DistributionLogsTable,
        DocumentHeader
},
    props:{
        text:{
            required: false,
            default:function(){
                return '';
            }
        },
        readOnly:{
            default:function(){
                return false;
            }
        },
        isPublished: {
            required: true
        },
        type:{},
        revision:{},
        b64:{
            default: null,
        }
    },
    watch:{
        text(newValue){
            if( newValue != null){
                this.pause_event = true;
                this.$nextTick(()=>{
                    //this.editor.setData(newValue);
                    this.content = newValue;
                    //set document to read only if displaying full document
                    //this.isReadOnly = (this.type == null ? true : false);

                    this.$nextTick(()=>{
                        this.pause_event = false;
                    })
                })
            }
        },
        b64(){
            this.show_pdf_wrapper = false;
            this.$nextTick(()=>{
                this.show_pdf_wrapper = true;
            })
        }
    },
    computed:{
        ...userState,
        isPdfRevision(){
            //return true if revision has pdf src (s3_cache_src)
            if(this.canShowHeader && this.revision.s3_cache_src != null){
                return true
            }
            else{
                return false;
            }
        },
        isUploaderRevision(){
            if(this.hasRevisionData == false){
                //* for newly created documents, no default revision gets inserted
                return true;
            }

            return this.revision.created_by_builder == false && this.revision.id == -1;
        },
        hasRevisionData(){
            return this.revision != undefined;
        },
        canShowHeader() {
            if(this.revision == undefined){
                return false;
            }
            else{
                return true;
            }
        },
        header_details() {
            let data = {};
            if(this.revision){
                data = this.revision.header_config;
                // data = {
                //     doc_heading: '',
                //     doc_name: '',
                //     doc_description: this.revision.clint_doc_name,
                //     sop_number:  this.revision.clint_doc_name,
                //     revision_number: '',
                //     revise_by_date: '',
                //     effective_date: '',
                //     supersedes: '',
                //     company_logo: '',
                // }
            }
            else{
                data = {
                    doc_heading: '',
                    doc_name: '',
                    doc_description: '',
                    sop_number: '',
                    revision_number: '',
                    revise_by_date: '',
                    effective_date: '',
                    supersedes: '',
                    company_logo: '',
                }
            }
            return data;

        },
        isReadOnly() {
            return this.type == null ? true : false;
        },
        client_signatures(){
            let signatures = {
                signature: null,
                initial: null,

            }
            if(this.client_signature != null){
                signatures.signature = this.client_signature.signature_svg;
            }
            if(this.client_initial != null){
                signatures.initial = this.client_initial.signature_svg;
            }
            console.table(signatures);
            return signatures;
        },
        revision_uid(){
            if(this.hasRevisionData && this.revision.client_revision_id){
                return this.revision.client_revision_id;
            }
            else{
                return -1;
            }
        },
    },
    methods:{
        ...userMethods,
        ...sopMethods,
        insertMergeKey(text){
            if(this.type != null){
                this.editor.insertText(text);
            }
            else{
                Swal.fire({
                    toast: true,
                    position: 'top',
                    iconColor: 'lightBlue',
                    icon: 'info',
                    title:'Select a section to insert merge keys',
                    customClass: {     popup: 'info-toast' },
                    showConfirmButton: false,
                    timer: 3000, timerProgressBar: true
                });
            }
        },
        onEditorReady(editor) {
            this.editor = editor;
            let previousData = this.content;
            editor.on('blur', function() {
                const currentData = this.content;
                if (currentData !== previousData) {
                    this.sendDataToParent(currentData);
                    previousData = currentData;
                }
            }.bind(this));
        },
        getEditorContentHeight(){
            let editor = this.editor;
            var doc = editor.document.$;
            var height = doc.body.scrollHeight;
            return parseInt(height);
        },
        initEditor(){
            //this.isReadOnly = (this.type == null ? true : false);
            this.content = this.text;
        },
        sendDataToParent(content){
            //let text = this.editor.getData();
            //let text = this.content;
            let height = this.getEditorContentHeight();
            this.$emit('updatedSection', {text: content, height: height});
        },
        toggleSignMode(){
            this.sign_mode = !this.sign_mode;
            this.show_pdf_wrapper = false;
            this.$nextTick(()=>{
                this.show_pdf_wrapper = true;
            })
        },
        showSigningPadModal(){
            this.show_signature_modal = true;
            this.$nextTick(()=>{
                this.$bvModal.show('signatureModal')
            })
        }
    },
    mounted(){
        //this.$eventHub.$on('forceSaveSection', this.sopAdminMethods)
        window.inst = this;

        //this.content = this.text;
        this.hasMounted = true;
        this.$nextTick(()=>{
            this.initEditor();
        });

        this.header_table = header_data;

        this.$eventHub.$on('insertMergeKey', this.insertMergeKey);
        if(this.client_signature == null){
            this.loadClientSignature('signature');
        }
        if(this.client_initial == null){
            this.loadClientSignature('initial');
        }
    },
    beforeDestroy(){
        window.inst = null;
        //this.clearSopStore();
        this.$eventHub.$off('insertMergeKey');
    }
}
</script>
<style>
.cke_notification {
    display: none !important;
}
</style>
<style scoped>
/* ::v-deep ol {
    list-style-type: none !important;
}

::v-deep li ol {
  counter-reset: lis !important;
}

::v-deep li {
    counter-increment: lis !important;
}

::v-deep li::before {
    content: counters(lis, ".") ". " !important;
}

::v-deep li li::before {
    content: counters(lis, ".") " " !important;
} */

/* header stuff */
/* table, th, td {
    border: 1px solid black;
  }
  #table.tableT{
    width: 100%;
} */

.left-column-border{
    color: white;
    border-width: 0 0 0 1px; /* top right bottom left */
    border-style: solid;
    border-image: 
        linear-gradient(
            to bottom, 
            rgb(208, 208, 208), 
        rgba(0, 0, 0, 0)
    ) 1 100%;
    border-image-slice: 1; /* This is important to maintain the gradient effect */
    border-style: dashed dashed dashed dashed; /* top right bottom left */

}


</style>
